import React, { useState, useEffect } from 'react';
import './WorldClock.css';

const cities = [
  { name: 'New York', timeZone: 'America/New_York', flag: '🇺🇸' },
  { name: 'Toronto', timeZone: 'America/Toronto', flag: '🇨🇦' },
  { name: 'London', timeZone: 'Europe/London', flag: '🇬🇧' },
  { name: 'Chandigarh', timeZone: 'Asia/Kolkata', flag: '🇮🇳' },
];

const AnalogClock = ({ time }) => {
  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours() % 12;

  return (
    <svg width="130" height="130" viewBox="0 0 100 100" className="snow-clock-svg">
      {/* Outer ring */}
      <circle cx="50" cy="50" r="47" stroke="rgba(126,200,227,0.15)" strokeWidth="1" fill="none" />
      <circle cx="50" cy="50" r="45" stroke="rgba(126,200,227,0.3)" strokeWidth="0.5" fill="rgba(10,22,40,0.5)" />

      {/* Hour markers */}
      {[...Array(12)].map((_, i) => {
        const angle = (i * 30 - 90) * (Math.PI / 180);
        const x1 = 50 + 38 * Math.cos(angle);
        const y1 = 50 + 38 * Math.sin(angle);
        const x2 = 50 + 42 * Math.cos(angle);
        const y2 = 50 + 42 * Math.sin(angle);
        return (
          <line
            key={i}
            x1={x1} y1={y1} x2={x2} y2={y2}
            stroke={i % 3 === 0 ? 'rgba(126,200,227,0.8)' : 'rgba(255,255,255,0.3)'}
            strokeWidth={i % 3 === 0 ? '2' : '1'}
            strokeLinecap="round"
          />
        );
      })}

      {/* Hour hand */}
      <line
        x1="50" y1="50"
        x2={50 + 22 * Math.cos(((hours * 30 + minutes * 0.5) - 90) * (Math.PI / 180))}
        y2={50 + 22 * Math.sin(((hours * 30 + minutes * 0.5) - 90) * (Math.PI / 180))}
        stroke="#a8d8ea" strokeWidth="2.5" strokeLinecap="round"
      />

      {/* Minute hand */}
      <line
        x1="50" y1="50"
        x2={50 + 30 * Math.cos((minutes * 6 - 90) * (Math.PI / 180))}
        y2={50 + 30 * Math.sin((minutes * 6 - 90) * (Math.PI / 180))}
        stroke="#7ec8e3" strokeWidth="1.5" strokeLinecap="round"
      />

      {/* Second hand */}
      <line
        x1="50" y1="50"
        x2={50 + 36 * Math.cos((seconds * 6 - 90) * (Math.PI / 180))}
        y2={50 + 36 * Math.sin((seconds * 6 - 90) * (Math.PI / 180))}
        stroke="#e48b95" strokeWidth="1" strokeLinecap="round"
      />

      {/* Center dot */}
      <circle cx="50" cy="50" r="2.5" fill="#7ec8e3" />
      <circle cx="50" cy="50" r="1" fill="#0a1628" />
    </svg>
  );
};

const WorldClock = () => {
  const [times, setTimes] = useState({});

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const newTimes = {};
      cities.forEach((city) => {
        const cityTimeStr = now.toLocaleString('en-US', { timeZone: city.timeZone });
        newTimes[city.name] = new Date(cityTimeStr);
      });
      setTimes(newTimes);
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (time) => {
    if (!time) return '';
    return time.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <section className="snow-worldclock" id="global">
      <div className="snow-worldclock-inner">
        <div className="snow-section-header">
          <span className="snow-section-label">❆ Global Presence</span>
          <h2 className="snow-section-title">
            Achieve Cost Efficiency and Operational Excellence with Global Talent
          </h2>
        </div>

        <div className="snow-clocks-grid">
          {cities.map((city) => (
            <div key={city.name} className="snow-clock-card">
              <div className="snow-clock-flag">{city.flag}</div>
              <div className="snow-clock-name">{city.name}</div>
              <div className="snow-clock-face">
                {times[city.name] && <AnalogClock time={times[city.name]} />}
              </div>
              <div className="snow-clock-digital">
                {formatTime(times[city.name])}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorldClock;
